if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
          this.prevSlideButton = this.querySelector('button[name="previous-slide"]');
          this.nextSlideButton = this.querySelector('button[name="next-slide"]');

          this.prevSlideButton.addEventListener("click", this.changeSlide.bind(this));
          this.nextSlideButton.addEventListener("click", this.changeSlide.bind(this));
      }

        changeSlide(event) {
            event.preventDefault();
            const activeSlide = this.querySelector('[data-media-id].active');
            const sliderItems = this.querySelectorAll('[data-media-id]');
            if (event.currentTarget.name === "previous-slide") {
                const previousSlide =
                    activeSlide.previousElementSibling || sliderItems[sliderItems.length - 1];

                activeSlide.classList.remove('active');
                previousSlide.classList.add('active');
            } else if (event.currentTarget.name === "next-slide") {
                const nextSlide =
                    activeSlide.nextElementSibling || sliderItems[0];

                activeSlide.classList.remove('active');
                nextSlide.classList.add('active');
            }

            this.alignVideoSlide();
        }

        alignVideoSlide() {
            const currentSlide = this.querySelector('[data-media-id].active');
            const parentContainer = this.querySelector('.product-media-modal__content');
            parentContainer.scrollLeft = (currentSlide.offsetWidth - parentContainer.offsetWidth) / 2;

            const videoSlide = currentSlide.querySelector('video');
            if (videoSlide && videoSlide.readyState >= 3 && videoSlide.paused) {
                videoSlide.play();
            }
        }

      hide() {
        super.hide();
        [].forEach.call(document.querySelectorAll('#MainContent media-gallery slideshow-component .product__media-item video'), videoSlide => {
            if (videoSlide && videoSlide.readyState >= 3 && videoSlide.paused) {
                videoSlide.play();
            }
        })
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.alignVideoSlide();
      }
    }
  );
}
